import * as Types from '@trello/graphql/generated';

import DocumentNode from '@trello/graphql/documentNode';
import * as Apollo from '@apollo/client';
export const DeleteReactionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeleteReaction"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"idAction"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"reactionId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deleteReaction"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"idAction"},"value":{"kind":"Variable","name":{"kind":"Name","value":"idAction"}}},{"kind":"Argument","name":{"kind":"Name","value":"reactionId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"reactionId"}}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"client"}}]}]}}]} as unknown as DocumentNode;
const defaultOptions = {"context":{"operationName":"DeleteReaction","document":DeleteReactionDocument}} as const;
export type DeleteReactionMutationVariables = Types.Exact<{
  idAction: Types.Scalars['ID']['input'];
  reactionId: Types.Scalars['ID']['input'];
}>;


export type DeleteReactionMutation = (
  { __typename: 'Mutation' }
  & Pick<Types.Mutation, 'deleteReaction'>
);

export type DeleteReactionMutationFn = Apollo.MutationFunction<
  DeleteReactionMutation,
  DeleteReactionMutationVariables
>;

/**
 * __useDeleteReactionMutation__
 *
 * To run a mutation, you first call `useDeleteReactionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteReactionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteReactionMutation, { data, loading, error }] = useDeleteReactionMutation({
 *   variables: {
 *      idAction: // value for 'idAction'
 *      reactionId: // value for 'reactionId'
 *   },
 * });
 */
export function useDeleteReactionMutation(
  baseOptions?: Apollo.MutationHookOptions<
    DeleteReactionMutation,
    DeleteReactionMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    DeleteReactionMutation,
    DeleteReactionMutationVariables
  >(DeleteReactionDocument, options);
}
export type DeleteReactionMutationHookResult = ReturnType<
  typeof useDeleteReactionMutation
>;
export type DeleteReactionMutationResult =
  Apollo.MutationResult<DeleteReactionMutation>;
export type DeleteReactionMutationOptions = Apollo.BaseMutationOptions<
  DeleteReactionMutation,
  DeleteReactionMutationVariables
>;
